import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default class Mug extends Component {
  static propTypes = {
    iconClass: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stroke: PropTypes.string,
    fill: PropTypes.string,
    svgProps: PropTypes.object
  };

  static defaultProps = {
    iconClass: "",
    size: "inherit",
    stroke: "currentColor",
    fill: "currentColor",
    svgProps: {}
  };

  get defaultHeight() {
    return 64;
  }

  get defaultWidth() {
    return 64;
  }

  get size() {
    return this.props.size;
  }

  get width() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultWidth;
    return this.size;
  }

  get height() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultHeight;
    return this.size;
  }

  get viewBox() {
    return "0 0 64 64";
  }

  get classes() {
    const { iconClass } = this.props;
    return classnames("manicon-svg", iconClass);
  }

  get fill() {
    return this.props.fill;
  }

  get stroke() {
    return this.props.stroke;
  }

  render() {
    const baseSvgProps = {
      xmlns: "http://www.w3.org/2000/svg",
      className: this.classes,
      width: this.width,
      height: this.height,
      viewBox: this.viewBox,
      fill: this.fill
    };

    const svgProps = Object.assign(baseSvgProps, this.props.svgProps);

    return (
      <svg {...svgProps}>
        <path d="M43.6351862,20.8468456 L43.6294138,18.8467999 C48.2495738,18.8335191 52.5245009,21.2906646 54.8384438,25.2896052 C57.1523943,29.2885588 57.1523943,34.2193412 54.8384438,38.2182948 C52.5245009,42.2172354 48.2495738,44.6743809 43.6294138,44.6611001 L43.6351862,42.6610544 C47.5394482,42.672323 51.1519686,40.5959161 53.1073598,37.2166221 C55.0627556,33.8373203 55.0627556,29.6705797 53.1073598,26.2912779 C51.1519686,22.9119839 47.5394482,20.835577 43.6351862,20.8468456 Z M43.6361706,26.1516423 L43.6284294,24.1516001 C46.3514993,24.1411173 48.8722496,25.5877819 50.2368432,27.9442622 C51.6014455,30.3007576 51.6014455,33.2071424 50.2368432,35.5636378 C48.8722496,37.9201181 46.3514993,39.3667827 43.6284294,39.3562999 L43.6361706,37.3562577 C45.6428801,37.3640249 47.5004893,36.2979386 48.5060911,34.5613917 C49.5116962,32.824839 49.5116962,30.683061 48.5060911,28.9465083 C47.5004893,27.2099614 45.6428801,26.1438751 43.6361706,26.1516423 Z M15.8606,50.0456 L15.8610101,51.2337683 C15.9710878,51.3000998 16.1348162,51.3774304 16.3462568,51.4576282 C16.9950095,51.7036953 17.9830005,51.9383082 19.2330407,52.1388505 C21.8567437,52.5597677 25.4294837,52.8022 29.247,52.8022 C33.0645163,52.8022 36.6372563,52.5597677 39.2609593,52.1388505 C40.5109995,51.9383082 41.4989905,51.7036953 42.1477432,51.4576282 C42.3591262,51.3774522 42.522823,51.3001419 42.6329,51.2338225 L42.6329,50.0456137 L42.6324033,13.7037865 C42.5223274,13.6374699 42.3586331,13.5601633 42.1472537,13.4799914 C41.498503,13.2339335 40.5105131,12.999332 39.2604686,12.798801 C36.6367887,12.3779127 33.0640509,12.1355 29.2465,12.1355 C25.428949,12.1355 21.8562113,12.3779127 19.2325314,12.798801 C17.9824869,12.999332 16.994497,13.2339335 16.3457463,13.4799914 C16.134369,13.5601625 15.9706758,13.6374684 15.8606,13.7037845 L15.8606,50.0456 Z M13.8606,50.0459452 L13.8606,13.4433 C13.8606,11.1721553 20.3227697,10.1355 29.2465,10.1355 C38.1702302,10.1355 44.6324,11.1721553 44.6324,13.4433 L44.6329,50.0456 L44.6329,51.4943 C44.6329,53.7654546 38.1705554,54.8022 29.247,54.8022 C20.3234446,54.8022 13.8611,53.7654546 13.8611,51.4946452 L13.8606,50.0459452 Z M15.7760039,13.1261964 C15.773912,13.1246003 15.7718607,13.123014 15.7698501,13.1214377 C15.7741636,13.1248194 15.7796479,13.1306364 15.7857778,13.1389461 L15.7760039,13.1261964 Z M15.7760039,13.1261964 C15.876539,13.2029053 16.0708091,13.3023426 16.3457568,13.4066282 C16.9945095,13.6526952 17.9825005,13.8873082 19.2325407,14.0878505 C21.8562437,14.5087677 25.4289837,14.7512 29.2465,14.7512 C33.0640163,14.7512 36.6367563,14.5087677 39.2604593,14.0878505 C40.5104995,13.8873082 41.4984905,13.6526952 42.1472432,13.4066282 C42.4279119,13.3001726 42.6245106,13.1987693 42.7231499,13.1214377 C42.6978745,13.1412533 42.6324,13.2446823 42.6324,13.4433 L44.6324,13.4433 C44.6324,15.7144546 38.1700554,16.7512 29.2465,16.7512 C20.3229446,16.7512 13.8606,15.7144546 13.8606,13.4433 L15.8606,13.4433 C15.8606,13.2785784 15.8155664,13.1793281 15.7857778,13.1389461 L15.7760039,13.1261964 Z" />
      </svg>
    );
  }
}
